// кнопка "Выбрать" на экране выбора карт
export const eventSelectCard = (card) => {
  try {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cards_select_card',
        'eventCategory': 'cards_select_card',
        'eventAction': 'click'
      })
      window.yaCounter38953865.reachGoal('cards_select_card')
      window.yaCounter38953865.reachGoal('cards_select_card_' + normalizeCardName(card.title, card.slug))
    }
  } catch (error) {
    console.log('error start btn analytics', error);
  }
};

// кнопка "Перейти к оформлению" на втором шаге (настройка параметров карты)
export const eventGoToForm = () => {
  try {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cards_go_to_form',
        'eventCategory': 'cards_go_to_form',
        'eventAction': 'click'
      })
      window.yaCounter38953865.reachGoal('cards_go_to_form')
    }
  } catch (error) {
    console.log('error last screen analytics', error);
  }
};

export const eventEcommerceDetail = (card) => {
  try {
    const data = {
      'ecommerce': {
        'currencyCode': 'RUB',
        'detail': {
          'products': [
            {
              'id': card.id,
              'name': card.title,
              'price': card.price,
              'brand': 'Fitron'
            }
          ]
        }
      }
    }
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data)
    } else {
      console.log(data)
    }
  } catch (error) {
    console.log('error start btn analytics', error);
  }
}

// переход к выбору оплаты
export const eventSendForm = (card) => {
  try {
    const data = {
      'event': 'cards_go_to_issuance',
      'eventCategory': 'cards_go_to_issuance',
      'eventAction': 'click',
      'ecommerce': {
        'currencyCode': 'RUB',
        'add': {
          'products': [
            {
              'id': card.id,
              'name': card.title,
              'price': card.price,
              'brand': 'Fitron'
            }
          ]
        }
      }
    }
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data)
      window.yaCounter38953865.reachGoal('cards_go_to_issuance')
      window.yaCounter38953865.reachGoal('cards_go_to_issuance_' + normalizeCardName(card.title, card.slug))
    } else {
      console.log(data)
    }
  } catch (error) {
    console.log('error send main form analytics', error);
  }
};

// Нажатие на кнопку "оплатить"
export const eventSendPayment = (card) => {
  try {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'cards_pay',
        'eventCategory': 'cards_pay',
        'eventAction': 'click'
      })
      window.yaCounter38953865.reachGoal('cards_pay')
      window.yaCounter38953865.reachGoal('cards_pay_' + normalizeCardName(card.title, card.slug))
    }
  } catch (error) {
    console.log('error send form payment analytics', error);
  }
};

export const eventEcommercePurchase = (card) => {
  try {
    const data = {
      'ecommerce': {
        'currencyCode': 'RUB',
        'purchase': {
          'actionField': {
            'id': card.orderId,
            'revenue': card.price
          },
          'products': [
            {
              'id': card.id,
              'name': card.title,
              'price': card.price,
              'brand': 'Fitron',
              'quantity': 1
            }
          ]
        }
      }
    }
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data)
    } else {
      console.log(data)
    }
  } catch (error) {
    console.log('error start btn analytics', error);
  }
}

function normalizeCardName(title, slug) {
  let result = slug,
      cardName = title.toLowerCase().replace(/\s/g, '_')
  if (cardName === 'индивидуальный' || cardName === 'фестивальный') {
    result = 'individual'
  }
  if (cardName === 'семейный') {
    result = 'family'
  }
  if (cardName === 'студенческий') {
    result = 'student'
  }
  if (cardName === 'тест-драйв') {
    result = 'test_drive'
  }
  if (cardName === 'комфортный') {
    result = 'comfort'
  }
  if (cardName === 'сезонный') {
    result = 'season'
  }
  if (cardName === 'выгодный') {
    result = 'vygoda'
  }
  if (cardName === 'подписка') {
    result = 'subscription'
  }
  if (cardName === 'новогодний') {
    result = 'newyear'
  }

  return result
}